import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Staking overview',
  description:
    'These are your transaction details for staking {asset} to the {module}. Make sure to check if this is correct before submitting.',
  safetyModule: 'Safety Module',
  amount: 'Amount',
  stake: 'Stake {asset}',
  boxDescription: 'Please submit to stake',
  backToStaking: 'Back to staking',

  notEnoughBalance: 'Not enough {asset} to stake',
  buttonTitle: 'Stake',
});
